function validator(startDate: string | Date, endDate: string | Date): boolean {
  startDate = new Date(startDate)
  endDate = new Date(endDate)
  return endDate > startDate
}

const validatorEffectiveDate = function(this: any, rule: any, value: any, callback: any) {
  const expirationDate = this.data.expirationDate
  if (value && expirationDate && !validator(value, expirationDate)) {
    return callback(new Error(this.$t('performance.formulaConfig.effectiveDateTip')))
  }
  callback()
}

const validatorExpirationDate = function(this: any, rule: any, value: any, callback: any) {
  const effectiveDate = this.data.effectiveDate
  if (value && effectiveDate && !validator(effectiveDate, value)) {
    return callback(new Error(this.$t('performance.formulaConfig.expirationDateTip')))
  }
  callback()
}

const validatorStartMonth = function(this: any, rule: any, value: any, callback: any) {
  const endMonth = this.data.endMonth
  if (value && endMonth && !validator(value, endMonth)) {
    return callback(new Error(this.$t('common.dateTips[0]')))
  }
  callback()
}

const validatorEndMonth = function(this: any, rule: any, value: any, callback: any) {
  const statrtMonth = this.data.statrtMonth
  if (value && statrtMonth && !validator(statrtMonth, value)) {
    return callback(new Error(this.$t('common.dateTips[1]')))
  }
  callback()
}

export {
  validatorEffectiveDate,
  validatorExpirationDate,
  validatorStartMonth,
  validatorEndMonth
}
